<template>
  <div class="layout gap-2 ov-auto">
    <div
        v-for="(file, index) in galleryPhotos"
        :key="index"
        :selenium="`thumbnail-${index}`"
        class="layout-item flex-0-0">
      <thumbnail
          :src="file.thumbnail"
          selenium="thumbnail"
          @click.native="openGallery(index)"
      />
    </div>
    <portal to="MODAL" :order="key">
      <vk-gallery
          :key="key"
          v-if="showGallery"
          :images="galleryPhotos"
          :initial-index="activeIndex"
          @image-remove="deleteImage"
          @close="close"
      />
    </portal>
  </div>
</template>

<script>
import _uniqueId from 'lodash/uniqueId';

export default {
  name: 'gallery',
  components: {},
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    // TODO: this should be removed and added into the obj inside files prop to mimic vk-gallery
    deletable: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      key: parseInt(_uniqueId(), 10),
      activeIndex: -1,
      showGallery: false,
    };
  },
  computed: {
    // TODO: Remove this? this should be done in consumption not definition of the component
    galleryPhotos () {
      if (this.files[0]) {
        return !this.files.every(file => file.src && file.thumbnail)
          ? this.files
            .map(file => file && {
              ...file,
              src: file.src || file.url || file.asset_url || file.path || file.asset_path || file.asset_urls || '',
              thumbnail: file.thumbnail || file.thumbnail_path || file.asset_thumbnail_path || file.asset_path || file.asset_urls || file.url || file.asset_thumbnail_url || '',
              removable: this.deletable,
            })
            .filter(e => e)
          : this.files;
      }
      return [];
    },
  },
  methods: {
    openGallery (index) {
      this.activeIndex = index;
      this.showGallery = true;

      this.$events.$emit(this.$events.PRO_PHOTO_VIEWED, {
        ...this.files[this.activeIndex],
        jobID: this.$route.params.id,
      });
    },
    close () {
      this.showGallery = false;
    },
    deleteImage () {
      this.$emit('deleteImage', this.files[this.activeIndex].id);
    },
  },
};
</script>
